module.exports = __webpack_public_path__ + "img/phone_bead07a6.855053d7.svg";